import {Component, OnInit, Input, Pipe, PipeTransform} from "@angular/core";
import { InaxTranslatePipe } from '../../../@inax/translate';
import { InaxScriptService, MethodPropertyChangeEvent } from '../../../@inax/script';



@Component({
    selector: 'script-viewer',
    templateUrl: 'app/components/scriptviewer/scriptviewer.component.html',
    styleUrls: ['app/components/scriptviewer/scriptviewer.component.css']
})
export class ScriptViewerComponent implements OnInit {
    public scriptUnit: string = "ScriptTest";
    public functionName: string = "InvokeTest";
    public lastChange:Date;

    constructor(private _inaxScript: InaxScriptService) {
    }

    public ngOnInit() {
    }

    public onExecute() {
        try {
            this._inaxScript.invokeInClientContext(this.scriptUnit,this.functionName,[]).subscribe( (result: MethodPropertyChangeEvent) =>
            {
                if(result.Event != null){
                    console.log(`changed ${result.Event.Timestamp}`);
                    this.lastChange = result.Event.Timestamp;
                }

                if(result.IsFinished){
                    console.log("finished");
                }
            });
        } catch (error) {
            console.error(error);
        }
    }
}
